var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState, useMemo } from "react";
import { CheckBoxWrapper, CheckBoxMark, ErrorMessage, ShowMore } from "./Inputs.styled";

var CheckBox = function CheckBox(_a) {
  var text = _a.text,
      checked = _a.checked,
      errorMessage = _a.errorMessage,
      sneakPeak = _a.sneakPeak,
      props = __rest(_a, ["text", "checked", "errorMessage", "sneakPeak"]);

  var _b = useState(false),
      isExpand = _b[0],
      setExpand = _b[1];

  var textToShow = useMemo(function () {
    if (sneakPeak) {
      return isExpand ? text : sneakPeak;
    }

    return text;
  }, [isExpand, text, sneakPeak]);
  return React.createElement(CheckBoxWrapper, __assign({
    hasError: !!errorMessage
  }, props), textToShow, React.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: props.onchange
  }), React.createElement(CheckBoxMark, null), !!errorMessage && React.createElement(ErrorMessage, null, errorMessage), !!sneakPeak && React.createElement(ShowMore, {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setExpand(!isExpand);
    }
  }, React.createElement("span", null, isExpand ? "zwiń" : "rozwiń")));
};

export default CheckBox;